'use client';

import type { JSX } from 'react';

import clsx from 'clsx';

import { Overline } from 'DesignSystem3/Text/Overline';

import { KPOW_PERIODS, PERIOD_LABELS, type KpowPeriod } from '../kpowFormat';

interface KpowPeriodTabsProps {
    value: KpowPeriod;
    onChange: (period: KpowPeriod) => void;
}

/**
 * Chart time-range selector (All / 1 Day / 1 Week / 1 Month / YTD / QTD). Flat, financial-style tabs:
 * the selected tab gets a subtle grey fill and a 3px black underline; the rest are muted grey text.
 * Scrolls horizontally if the tabs outgrow the container (mobile).
 */
const KpowPeriodTabs = ({ value, onChange }: KpowPeriodTabsProps): JSX.Element => (
    <div className="flex min-w-0 flex-1 items-center gap-1 overflow-x-auto scrollbar-none">
        {KPOW_PERIODS.map((period) => (
            <button
                key={period}
                type="button"
                onClick={() => onChange(period)}
                aria-pressed={period === value}
                className={clsx(
                    'flex h-[40px] min-w-[32px] shrink-0 cursor-pointer items-center justify-center whitespace-nowrap border-0 border-b-[3px] border-solid px-3 transition-colors',
                    period === value
                        ? 'border-core-black bg-container-x30 text-text-x10'
                        : 'border-transparent bg-transparent text-text-x30 hover:text-text-x10',
                )}
            >
                <Overline.x20>{PERIOD_LABELS[period]}</Overline.x20>
            </button>
        ))}
    </div>
);

export default KpowPeriodTabs;
